/* hs-eslint ignored failing-rules */
/* eslint-disable compat/compat */
import { DragSource } from 'react-dnd-compat';
import { dragTypes } from 'InpageEditorUI/lib/layoutSection/constants';
import { draggingStartedAndDeselectExisting as draggingStartedAndDeselectExistingAction, draggingStoppedAndReselectIfNeeded as draggingStoppedAndReselectIfNeededAction, layoutSectionNodePositionsCleared
// @ts-expect-error not typed yet
} from 'InpageEditorUI/redux/actions/layoutSectionDndActions';
import { Component } from 'react';
// @ts-expect-error not typed yet
import { getEmptyImage } from 'react-dnd-ipeui-backend';
import { connect } from 'react-redux';
import { getHoveredModuleRowOrColumnInfo, getIsAnythingDragging, getTargetedLayoutSectionId, getShouldShowGridAndToolbars, getHasInsertNewSectionHandleHovered, getHighlightedNodePositionInfo, getStaticSectionNodePositionForStaticModuleId } from 'InpageEditorUI/redux/selectors/layoutSectionDndSelectors';
import { getIsModuleEditable, getIsGlobalModuleGroupOrPartial, getModuleById, getPostBodyCustomModuleParentIds, selectIsPostBodyModule, getAllLayoutSectionTreesAsMap } from 'ContentEditorUI/redux/selectors/moduleSelectors';
import { getIsAdvancedModuleWithoutAccess, getModuleHasPaymentsFieldWithoutAccess, getModuleHasPersonalizationTokensWithoutAccess
// @ts-expect-error not typed yet
} from 'ContentEditorUI/redux/selectors/downgradeSelectors';
import { getHasContentEmbedAccess, getHasGlobalContentEditorAccess, getIsUngatedToRepositionPostBodyModules } from 'ContentEditorUI/redux/selectors/authSelectors';
// @ts-expect-error not typed yet
import { updateSelectedItem as updateSelectedItemAction } from 'ContentEditorUI/redux/actions/selectionActions';
import LayoutSectionHoverOverlay from 'InpageEditorUI/components/LayoutSectionHoverOverlay';
import { OFFSCREEN_POSITION } from 'InpageEditorUI/lib/layoutSection/constants';
import { getIsInDefaultBreakpointMode } from 'ContentEditorUI/redux/selectors/styleBreakpointsSelectors';
import { getSelectedItemId } from 'ContentEditorUI/redux/selectors/selectionSelectors';
// @ts-expect-error not typed yet
import { isDndAreaColumn } from 'layout-dnd-utils/dom/dndAreaDomSelectors';
import { getDefaultType } from 'ContentEditorUI/redux/selectors/moduleSelectors';
// @ts-expect-error not typed yet
import { getIsSmartContentPreview } from 'ContentEditorUI/redux/selectors/iframesSelectors';
import { INLINE_TYPES } from 'ContentEditorUI/lib/inpage/Constants';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { getIsDataAuthoringModeActive } from 'ContentEditorUI/redux/selectors/instanceEditingSelectors';
import { getCanDragLayouts } from 'InpageEditorUI/redux/selectors/layoutSectionDndSelectors';
import { View } from 'foundations-components/transitional/components/View';
// @ts-expect-error untyped modules
import EditorConfigSingleton from 'ContentEditorUI/EditorConfigSingleton';
import { jsx as _jsx } from "react/jsx-runtime";
const dragSource = {
  beginDrag(props, monitor, component) {
    var _EditorConfigSingleto;
    const {
      hoveredNodeInfo,
      parentSectionNodePositionForStaticModule,
      draggingStartedAndDeselectExisting,
      targetedLayoutSectionId
    } = props;
    const allowStaticModuleDragToMoveParentSection = ((_EditorConfigSingleto = EditorConfigSingleton.get('inpage')) === null || _EditorConfigSingleto === void 0 ? void 0 : _EditorConfigSingleto.allowStaticModuleDragToMoveParentSection) || false;
    let dragItem;
    if (hoveredNodeInfo !== null && hoveredNodeInfo !== void 0 && hoveredNodeInfo.isStaticSectionModule && parentSectionNodePositionForStaticModule && allowStaticModuleDragToMoveParentSection) {
      // For static section modules, create a delegate drag item using the parent section
      dragItem = {
        dragId: parentSectionNodePositionForStaticModule.id,
        dragParentId: parentSectionNodePositionForStaticModule.parentId,
        isColumn: false,
        isRow: parentSectionNodePositionForStaticModule.isRow,
        isTopMostRow: parentSectionNodePositionForStaticModule.isTopMostRow,
        originLayoutSectionId: parentSectionNodePositionForStaticModule.parentId,
        isPostBodyModule: false
      };
    } else {
      dragItem = {
        dragId: hoveredNodeInfo === null || hoveredNodeInfo === void 0 ? void 0 : hoveredNodeInfo.id,
        dragParentId: hoveredNodeInfo === null || hoveredNodeInfo === void 0 ? void 0 : hoveredNodeInfo.parentId,
        isColumn: hoveredNodeInfo === null || hoveredNodeInfo === void 0 ? void 0 : hoveredNodeInfo.isColumn,
        isRow: hoveredNodeInfo === null || hoveredNodeInfo === void 0 ? void 0 : hoveredNodeInfo.isRow,
        isTopMostRow: hoveredNodeInfo === null || hoveredNodeInfo === void 0 ? void 0 : hoveredNodeInfo.isTopMostRow,
        originLayoutSectionId: targetedLayoutSectionId,
        isPostBodyModule: hoveredNodeInfo === null || hoveredNodeInfo === void 0 ? void 0 : hoveredNodeInfo.isPostBodyModule
      };
    }

    // Save the hover info to keep rendering while dragging (otherwise if the DOM being dragged goes
    // away or is restyled significantly, then the drag will stop)
    component.hoveredNodeInfoFromDrag = hoveredNodeInfo;
    if (hoveredNodeInfo && !hoveredNodeInfo.isPostBodyModule) {
      draggingStartedAndDeselectExisting(dragItem);
    }
    return dragItem;
  },
  canDrag(props) {
    return props.canDrag;
  },
  endDrag(props, monitor, component) {
    const {
      draggingStoppedAndReselectIfNeeded
    } = props;
    delete component.hoveredNodeInfoFromDrag;
    if (!monitor.getItem().isPostBodyModule) {
      draggingStoppedAndReselectIfNeeded(monitor.getItem(), monitor.didDrop());
    }
  }
};
function dragCollect(monitor) {
  return {
    isDragging: monitor.isDragging()
  };
}
const mapStateToProps = state => {
  var _EditorConfigSingleto2;
  const hoveredNodeInfo = getHoveredModuleRowOrColumnInfo(state);
  const highlightedNodePositionInfo = getHighlightedNodePositionInfo(state);
  const hoveredOrHighlightedNodeInfo = highlightedNodePositionInfo || hoveredNodeInfo;

  // Find parent section node position for static section modules
  let parentSectionNodePositionForStaticModule = null;
  const allowStaticModuleDragToMoveParentSection = ((_EditorConfigSingleto2 = EditorConfigSingleton.get('inpage')) === null || _EditorConfigSingleto2 === void 0 ? void 0 : _EditorConfigSingleto2.allowStaticModuleDragToMoveParentSection) || false;
  if (hoveredNodeInfo !== null && hoveredNodeInfo !== void 0 && hoveredNodeInfo.isStaticSectionModule && hoveredNodeInfo.id && allowStaticModuleDragToMoveParentSection) {
    // If hovering on a static section module, get the parent section node position
    parentSectionNodePositionForStaticModule = getStaticSectionNodePositionForStaticModuleId(state);
  }
  const isStaticOrFlexColumnModule = !!(hoveredNodeInfo && (hoveredNodeInfo.isStaticModule || hoveredNodeInfo.isFlexColumnModule || hoveredNodeInfo.isGlobalGroup || hoveredNodeInfo.isGlobalPartial));

  // If hovering on any _left_ node any module/global in a container or not (but _not_ any row or column )
  const isHoveringOnItem = Boolean(hoveredNodeInfo && (hoveredNodeInfo.isModule || hoveredNodeInfo.isGlobalGroup || hoveredNodeInfo.isGlobalPartial));

  // Is highlighting any module/global (but _not_ any row or column)
  const isHighlightingItem = Boolean(highlightedNodePositionInfo && (highlightedNodePositionInfo.isModule || highlightedNodePositionInfo.isGlobalGroup || highlightedNodePositionInfo.isGlobalPartial));
  const isInDefaultBreakpointMode = getIsInDefaultBreakpointMode(state);
  const isSmartContentPreview = getIsSmartContentPreview(state);
  const selectedItemId = getSelectedItemId(state);
  const isInDataAuthoringMode = getIsDataAuthoringModeActive(state);
  const isPostBodyModule = hoveredNodeInfo && hoveredNodeInfo.isModule && hoveredNodeInfo.id && selectIsPostBodyModule(state, {
    moduleName: hoveredNodeInfo.id
  });
  const isUngatedToRepositionPostBodyModules = getIsUngatedToRepositionPostBodyModules(state);
  const isStaticSectionModule = Boolean(hoveredNodeInfo && hoveredNodeInfo.isStaticSectionModule);
  const isDraggableStaticSectionModule = isStaticSectionModule && allowStaticModuleDragToMoveParentSection;
  const isNondraggableModule = isStaticOrFlexColumnModule || isPostBodyModule && !isUngatedToRepositionPostBodyModules;

  // Calculate canDrag logic
  const canDragInCurrentContext = isInDefaultBreakpointMode && !isSmartContentPreview && (!isNondraggableModule || isDraggableStaticSectionModule) && !isInDataAuthoringMode;
  const canDragLayouts = getCanDragLayouts(state);
  const canDrag = canDragInCurrentContext && canDragLayouts;
  return {
    selectedItemId,
    hasContentEmbedAccess: getHasContentEmbedAccess(state),
    parentSectionNodePositionForStaticModule,
    hasGlobalContentEditorAccess: getHasGlobalContentEditorAccess(state),
    hoveredNodeInfo,
    hoveredOrHighlightedNodeInfo,
    highlightedNodePositionInfo,
    isHighlightingItem,
    isHoveringOnContainerWhileItemIsSelected: Boolean(selectedItemId && !isHoveringOnItem),
    isUneditableItem: Boolean(isHoveringOnItem && hoveredNodeInfo && !getIsModuleEditable(state, hoveredNodeInfo.id)),
    isGlobal: !!hoveredOrHighlightedNodeInfo && getIsGlobalModuleGroupOrPartial(state, hoveredOrHighlightedNodeInfo.id),
    isAnythingDragging: getIsAnythingDragging(state),
    targetedLayoutSectionId: getTargetedLayoutSectionId(state),
    shouldShowGridAndToolbars: getShouldShowGridAndToolbars(state),
    isInDefaultBreakpointMode,
    defaultType: hoveredOrHighlightedNodeInfo && getDefaultType(state, hoveredOrHighlightedNodeInfo.id),
    isSmartContentPreview,
    isStaticOrFlexColumnModule,
    canDrag,
    isAdvancedModuleWithoutAccess: hoveredOrHighlightedNodeInfo && hoveredOrHighlightedNodeInfo.isModule ? getIsAdvancedModuleWithoutAccess(state, getModuleById(state, hoveredOrHighlightedNodeInfo.id)) : false,
    isPaymentsModuleWithoutAccess: hoveredOrHighlightedNodeInfo && hoveredOrHighlightedNodeInfo.isModule ? getModuleHasPaymentsFieldWithoutAccess(state, getModuleById(state, hoveredOrHighlightedNodeInfo.id)) : false,
    hasPersonalizationTokenWithoutAccess: hoveredOrHighlightedNodeInfo && hoveredOrHighlightedNodeInfo.isModule ? getModuleHasPersonalizationTokensWithoutAccess(state, getModuleById(state, hoveredOrHighlightedNodeInfo.id)) : false,
    postBodyCustomModuleParentIds: hoveredNodeInfo && hoveredNodeInfo.isModule && selectedItemId === 'post_body' ? getPostBodyCustomModuleParentIds(state) : null,
    isInsertNewSectionHandleHovered: getHasInsertNewSectionHandleHovered(state),
    isInDataAuthoringMode,
    allLayoutSectionTrees: getAllLayoutSectionTreesAsMap(state)
  };
};
const mapDispatchToProps = {
  draggingStartedAndDeselectExisting: draggingStartedAndDeselectExistingAction,
  draggingStoppedAndReselectIfNeeded: draggingStoppedAndReselectIfNeededAction,
  updateSelectedItem: updateSelectedItemAction,
  layoutSectionNodePositionsCleared
};
class HoverOverlayContainer extends Component {
  // Add class field for ref

  constructor(props) {
    super(props);
    this.ref = null;
    this.hideMobileInlineEditableTooltip = () => {
      this.setState({
        showTooltipForInlineMobile: false
      });
    };
    this.onClick = this.onClick.bind(this);
    this.onEventPassthrough = this.onEventPassthrough.bind(this);
    this.state = {
      showTooltipForInlineMobile: false
    };
  }
  componentDidMount() {
    const {
      connectDragPreview
    } = this.props;
    connectDragPreview(getEmptyImage(), {
      captureDraggingState: true
    });
  }
  componentDidUpdate(prevProps) {
    const {
      hoveredNodeInfo
    } = this.props;
    if (prevProps.hoveredNodeInfo !== hoveredNodeInfo) {
      this.hideMobileInlineEditableTooltip();
    }
  }
  onClickNonContainerItem(e) {
    var _this$ref;
    // Hide the overlay so the "elementFromPoint" and "caretRangeFromPoint" (in WidgetEditor.js) can get at the elements underneath the overlay
    const originalRefDisplay = ((_this$ref = this.ref) === null || _this$ref === void 0 ? void 0 : _this$ref.style.display) || 'block';
    if (this.ref) {
      this.ref.style.display = 'none';
    }
    const elementAtPoint = document.elementsFromPoint(e.clientX, e.clientY)[0];
    let horizontalDispatchPoint;
    let verticalDispatchPoint;
    let target;
    if (isDndAreaColumn(elementAtPoint)) {
      // Click on the top/left of the child element (per: https://git.hubteam.com/HubSpot/ContentEditorUI/issues/6998)
      const firstElementChild = elementAtPoint.children[0];
      const bounds = firstElementChild.getBoundingClientRect();
      horizontalDispatchPoint = bounds.left;
      verticalDispatchPoint = bounds.top;
      target = firstElementChild;
    } else {
      horizontalDispatchPoint = e.clientX;
      verticalDispatchPoint = e.clientY;
      target = elementAtPoint;
    }

    // Take horizontal/vertical dispatch points and refire a click event at the target
    target.dispatchEvent(new MouseEvent(e.type, {
      cancelable: true,
      bubbles: true,
      clientX: horizontalDispatchPoint,
      clientY: verticalDispatchPoint
    }));
    // Put overlay back the way we found it
    if (this.ref) {
      this.ref.style.display = originalRefDisplay;
    }
  }
  isMobileInlineEditable() {
    const {
      defaultType,
      isInDefaultBreakpointMode
    } = this.props;
    return !isInDefaultBreakpointMode && INLINE_TYPES.includes(defaultType);
  }
  getFirstModuleInStaticSection(staticSectionId) {
    const {
      allLayoutSectionTrees
    } = this.props;
    if (!allLayoutSectionTrees || !staticSectionId) {
      return null;
    }

    // Find the static section in the layout trees
    for (const [__treeId, tree] of Object.entries(allLayoutSectionTrees)) {
      // Get rows from the tree
      const rows = tree.getRootCell().getRows();
      for (const row of rows) {
        // Look through all rows in the tree to find static sections
        if (row.isStaticSection()) {
          if (row.getName() === staticSectionId) {
            const moduleChildren = row.getModuleChildren();
            if (moduleChildren && moduleChildren.length > 0) {
              return moduleChildren[0].getName();
            }
          }
        }
      }
    }
    return null;
  }
  onClick(e) {
    const {
      hoveredNodeInfo,
      targetedLayoutSectionId,
      updateSelectedItem
    } = this.props;

    // Handle clicks on static sections by redirecting to the first child module
    if (hoveredNodeInfo && hoveredNodeInfo.isStaticSection && !hoveredNodeInfo.isStaticModule) {
      var _EditorConfigSingleto3;
      const allowStaticModuleDragToMoveParentSection = ((_EditorConfigSingleto3 = EditorConfigSingleton.get('inpage')) === null || _EditorConfigSingleto3 === void 0 ? void 0 : _EditorConfigSingleto3.allowStaticModuleDragToMoveParentSection) || false;
      if (allowStaticModuleDragToMoveParentSection) {
        const firstModuleId = this.getFirstModuleInStaticSection(hoveredNodeInfo.id);
        if (firstModuleId) {
          updateSelectedItem(firstModuleId, {
            containerId: targetedLayoutSectionId
          });
          return;
        }
      }

      // Force recomputation of node positions
      this.props.layoutSectionNodePositionsCleared();
      return;
    }
    if (this.isMobileInlineEditable()) {
      // Can't click on inline editable modules in mobile, show the tooltip.
      this.setState({
        showTooltipForInlineMobile: true
      });
      updateSelectedItem(hoveredNodeInfo === null || hoveredNodeInfo === void 0 ? void 0 : hoveredNodeInfo.id, {
        containerId: targetedLayoutSectionId,
        activeTab: 'style'
      });
    } else if (hoveredNodeInfo && (hoveredNodeInfo.isModule || hoveredNodeInfo.isGlobalGroup || hoveredNodeInfo.isGlobalPartial || hoveredNodeInfo.isEmbed)) {
      this.onClickNonContainerItem(e);
    } else {
      // If a section/row/column is clicked, trigger its selection
      updateSelectedItem(hoveredNodeInfo === null || hoveredNodeInfo === void 0 ? void 0 : hoveredNodeInfo.id, {
        containerId: targetedLayoutSectionId
      });
    }
    // Otherwise act like this onClick never happened

    return;
  }
  onEventPassthrough(e) {
    const {
      hoveredNodeInfo
    } = this.props;

    // Ignore events on static sections that are not actually static modules
    if (hoveredNodeInfo && hoveredNodeInfo.isStaticSection && !hoveredNodeInfo.isStaticModule) {
      return;
    }
    if (hoveredNodeInfo && (hoveredNodeInfo.isModule || hoveredNodeInfo.isGlobalGroup || hoveredNodeInfo.isGlobalPartial)) {
      this.onClickNonContainerItem(e);
    }
  }
  render() {
    const {
      selectedItemId,
      hasContentEmbedAccess,
      hasGlobalContentEditorAccess,
      hoveredNodeInfo,
      isHoveringOnContainerWhileItemIsSelected,
      isUneditableItem,
      isGlobal,
      canDrag,
      shouldShowGridAndToolbars,
      connectDragSource,
      isAnythingDragging,
      isAdvancedModuleWithoutAccess,
      defaultType,
      postBodyCustomModuleParentIds,
      isInsertNewSectionHandleHovered,
      isPaymentsModuleWithoutAccess,
      hasPersonalizationTokenWithoutAccess,
      hoveredOrHighlightedNodeInfo,
      highlightedNodePositionInfo,
      isHighlightingItem,
      isInDataAuthoringMode
    } = this.props;
    const {
      showTooltipForInlineMobile
    } = this.state;
    let fadeOutOverlayDuringDrag = false;
    let overlayInfo;
    const OFFSCREEN_OVERLAY = {
      top: OFFSCREEN_POSITION.TOP,
      left: OFFSCREEN_POSITION.LEFT,
      width: 0,
      height: 0,
      isModule: false
    };
    if (isAnythingDragging && this.hoveredNodeInfoFromDrag) {
      overlayInfo = this.hoveredNodeInfoFromDrag;
      fadeOutOverlayDuringDrag = true;
    } else if (hoveredOrHighlightedNodeInfo &&
    // if something is selected, we should only show the overlay if we're hovering on a module
    !isHoveringOnContainerWhileItemIsSelected && !isInsertNewSectionHandleHovered) {
      overlayInfo = hoveredOrHighlightedNodeInfo;
    } else {
      // Have the default position be way off screen to prevent borders from bleeding onto the page
      // (and to keep these components mounted for perf even if not visible)
      overlayInfo = OFFSCREEN_OVERLAY;
    }
    if (isInDataAuthoringMode && hoveredNodeInfo && !(hoveredNodeInfo.isModule || isGlobal)) {
      overlayInfo = OFFSCREEN_OVERLAY;
    }
    const {
      top,
      left
    } = overlayInfo;
    const isAlreadyFocused = hoveredNodeInfo && hoveredNodeInfo.id === selectedItemId || selectedItemId === 'post_body' && hoveredNodeInfo && postBodyCustomModuleParentIds && postBodyCustomModuleParentIds.length > 0 && postBodyCustomModuleParentIds.includes(hoveredNodeInfo.id);
    let tooltipTitleText = 'inpage.actionToolbar.module.cantEditMobile';
    let headingText;
    if (isAdvancedModuleWithoutAccess || isPaymentsModuleWithoutAccess || hasPersonalizationTokenWithoutAccess) {
      if (hasPersonalizationTokenWithoutAccess) {
        tooltipTitleText = 'moduleHoverMenu.overlayTooltips.moduleWithPTokenToPublish';
        headingText = 'moduleHoverMenu.overlayTooltips.richTextModuleWithCtaOrVideoModules';
      } else if (defaultType === 'rich_text' || defaultType === 'video') {
        tooltipTitleText = `moduleHoverMenu.overlayTooltips.${defaultType === 'video' ? 'videoModuleWithHsVideoToPublish' : 'richTextRemoveCtaOrVideosToPublish'}`;
        headingText = 'moduleHoverMenu.overlayTooltips.richTextModuleWithCtaOrVideoModules';
      } else {
        tooltipTitleText = 'moduleHoverMenu.overlayTooltips.deleteToPublish';
        headingText = 'moduleHoverMenu.overlayTooltips.remove';
      }
    }
    let cursor = 'move';
    if ((isUneditableItem || isGlobal && !hasGlobalContentEditorAccess) && defaultType !== 'blog_audio') {
      cursor = 'not-allowed';
    } else if (isGlobal || !canDrag) {
      cursor = 'pointer';
    }
    const hasModuleAccess = !isAdvancedModuleWithoutAccess && !isPaymentsModuleWithoutAccess && !hasPersonalizationTokenWithoutAccess;
    const hasGlobalAccess = isGlobal && hasGlobalContentEditorAccess;
    const showNoAccessToolTip = showTooltipForInlineMobile || !hasModuleAccess && !isAlreadyFocused;
    const showGlobalToolTip = hasGlobalAccess && !showNoAccessToolTip;
    if (showGlobalToolTip) {
      tooltipTitleText = 'moduleHoverMenu.overlayTooltips.globalContent';
    }
    const hideOverlay = (!shouldShowGridAndToolbars || !this.isMobileInlineEditable() && isAlreadyFocused) && (!highlightedNodePositionInfo || isHighlightingItem);
    const isEmbed = Boolean(hoveredNodeInfo === null || hoveredNodeInfo === void 0 ? void 0 : hoveredNodeInfo.isEmbed);
    const isStaticSectionModule = Boolean(hoveredNodeInfo === null || hoveredNodeInfo === void 0 ? void 0 : hoveredNodeInfo.isStaticSectionModule);
    return /*#__PURE__*/_jsx(View, {
      as: "div",
      display: hideOverlay ? 'none' : 'block',
      children: /*#__PURE__*/_jsx(Tooltip, {
        open: !hideOverlay && (showGlobalToolTip || showNoAccessToolTip),
        disabled: hideOverlay,
        headingText: (isAdvancedModuleWithoutAccess || isPaymentsModuleWithoutAccess || hasPersonalizationTokenWithoutAccess) && /*#__PURE__*/_jsx(FormattedMessage, {
          message: headingText
        }),
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: tooltipTitleText
        }),
        autoPlacement: true,
        placement: "bottom",
        use: !hasModuleAccess && !showTooltipForInlineMobile ? 'longform' : 'default',
        children: /*#__PURE__*/_jsx(LayoutSectionHoverOverlay, {
          hasContentEmbedAccess: hasContentEmbedAccess,
          hasGlobalContentEditorAccess: hasGlobalContentEditorAccess,
          onClick: this.onClick,
          onMouseUp: this.onEventPassthrough,
          onMouseDown: this.onEventPassthrough,
          height: overlayInfo.height,
          id: overlayInfo.id,
          isGlobal: isGlobal,
          left: Math.round(left),
          domNodeRef: ref => {
            this.ref = ref;
            connectDragSource(this.ref);
          },
          top: Math.round(top),
          width: Math.round(overlayInfo.width),
          isFixedPosition: overlayInfo.isFixedPosition,
          opacity: fadeOutOverlayDuringDrag ? 0 : 1,
          isUneditable: isUneditableItem,
          isAdvancedModuleWithoutAccess: isAdvancedModuleWithoutAccess,
          isPaymentsModuleWithoutAccess: isPaymentsModuleWithoutAccess,
          hasPersonalizationTokenWithoutAccess: hasPersonalizationTokenWithoutAccess,
          defaultType: defaultType,
          cursor: isAnythingDragging ? undefined : cursor,
          pointerEvents: isAnythingDragging ? undefined : 'auto',
          isEmbed: isEmbed,
          isStaticSectionModule: isStaticSectionModule
        })
      })
    });
  }
}
const connector = connect(mapStateToProps, mapDispatchToProps);
export default connector(DragSource(dragTypes.EXISTING_ITEM, dragSource, dragCollect)(HoverOverlayContainer));